import BaseInstitutionEntity from "@/models/Shared/BaseInstitutionEntity";
import EntityIdentifier from "@/models/Shared/EntityIdentifier";

export default class RateSource extends BaseInstitutionEntity {
    name: string = '';
    currentRate: number = 0;
    baseRate: boolean = false;
    baseRateSourceIdentifier: EntityIdentifier;
    createdAtUtc: Date;
    updatedAtUtc: Date;
}